export const quoteOptionsCurrencyType = {
  none: 1,
  subTotals: 2,
  subTotalsConverted: 3,
  subTotalsConvertedWithFreight: 4,
  chargesConverted: 5,
};
